import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';
import {CoverNote, RecordCount} from '../../Config/dataModel';

interface CoverNoteContainerProps {
    newRecord?: CoverNote,
    newCount?: RecordCount
}

class CoverNoteContainer extends React.Component <CoverNoteContainerProps, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.COVER_NOTE} newRecord={this.props.newRecord} newCount={this.props.newCount}/>
        );
    }
}

export default CoverNoteContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/CoverNoteContainer.tsx